export default __webpack_public_path__ + "static/media/form.c294cf01.png";